import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierProfile.components.PaymentBanking.title',
    defaultMessage: 'Payment and banking',
  },
  subtitle: {
    id: 'containers.SupplierProfile.components.PaymentBanking.subtitle',
    defaultMessage: 'Please provide our finance team with your banking and payment details. You won\'t need to send us an invoice. Each month you will receive a statement from VoiceArchive showing the tasks that you have been assigned and how much you are due for that assignment.\n\nYou can read more about our reverse invoicing here <link>https://www.voicearchive.com/voice-talent-faqs/</link>',
  },
  validationFailed: {
    id: 'containers.SupplierProfile.components.PaymentBanking.validationFailed',
    defaultMessage: 'Address or company details are not complete',
  },
  euvatidLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.euvatid.label',
    defaultMessage: 'VAT',
  },
  euvatidPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.euvatid.placeholder',
    defaultMessage: 'Including country code (i.e. DK12345678)',
  },
  companyLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.company.label',
    defaultMessage: 'Legal entity name',
  },
  companyPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.company.placeholder',
    defaultMessage: 'Enter legal entity name of your business',
  },
  cityLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.city.label',
    defaultMessage: 'City',
  },
  cityPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.city.placeholder',
    defaultMessage: 'Enter city here',
  },
  zipLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.zip.label',
    defaultMessage: 'ZIP/Postal Code',
  },
  zipPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.zip.placeholder',
    defaultMessage: 'Enter ZIP or postal code here',
  },
  addressLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.address.label',
    defaultMessage: 'Address',
  },
  addressPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.address.placeholder',
    defaultMessage: 'Enter your business address here',
  },
  stateLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.state.label',
    defaultMessage: 'State',
  },
  statePlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.state.placeholder',
    defaultMessage: 'Enter state (if applicable)',
  },
  countryLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.country.label',
    defaultMessage: 'Country',
  },
  countryPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.country.placeholder',
    defaultMessage: 'Select country of your business',
  },
  currencyLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.currency.label',
    defaultMessage: 'Currency',
  },
  currencyPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.currency.placeholder',
    defaultMessage: 'Select currency',
  },
  account_holderLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.account_holder.label',
    defaultMessage: 'Account holder',
  },
  account_holderPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.account_holder.placeholder',
    defaultMessage: 'Name as shown on your bank statement',
  },
  account_branch_codeLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.account_branch_code.label',
    defaultMessage: 'Branch code',
  },
  account_branch_codePlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.account_branch_code.placeholder',
    defaultMessage: 'Sort Code/ABA',
  },
  account_branch_codeInfo: {
    id: 'containers.SupplierProfile.components.PaymentBanking.account_branch_code.info',
    defaultMessage: 'ABA\nRouting Number\nRegistration Number\nSort Code\netc.',
  },
  account_numberLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.account_number.label',
    defaultMessage: 'Account number',
  },
  account_numberPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.account_number.placeholder',
    defaultMessage: 'Account number',
  },
  bicLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.bic.label',
    defaultMessage: 'BIC/SWIFT',
  },
  bicPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.bic.placeholder',
    defaultMessage: 'Enter 8 or 11 characters long BIC/SWIFT code',
  },
  ibanLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.iban.label',
    defaultMessage: 'IBAN',
  },
  ibanPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.iban.placeholder',
    defaultMessage: 'Enter IBAN if applicable',
  },
  bank_addressLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.bank_address.label',
    defaultMessage: 'Bank address',
  },
  bank_addressPlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.bank_address.placeholder',
    defaultMessage: 'Bank address (required for accounts in the United States)',
  },
  bank_nameLabel: {
    id: 'containers.SupplierProfile.components.PaymentBanking.bank_name.label',
    defaultMessage: 'Bank name',
  },
  bank_namePlaceholder: {
    id: 'containers.SupplierProfile.components.PaymentBanking.bank_name.placeholder',
    defaultMessage: 'Bank name',
  },
  vatRegistered: {
    id: 'containers.SupplierProfile.components.PaymentBanking.vatRegistered',
    defaultMessage: 'VAT registered?',
  },
})
